"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ImageAnimation = _interopRequireDefault(require("../../anim/ImageAnimation"));
var _TileAnimation = _interopRequireDefault(require("../../anim/TileAnimation"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
class TileDataAnimator {
  constructor(source, opts) {
    this.source = source;
    const anim = opts.type === 'image' ? new _ImageAnimation.default(null, opts) : new _TileAnimation.default(opts);
    anim.provider = this;
    anim.on('stop reset', e => {
      anim.hide();
      source.updateVisibility();
    });
    if (opts.type === 'tile') {
      anim.on('load:progress', e => {
        if (anim.showWhenLoading) {
          source.hide();
        }
      }).on('play', e => {
        source.hide();
      });
      anim.on("advance:image" /* AnimationEvent.ADVANCE_IMAGE */, () => {});
    }
    this.animation = anim;
    source.on('overlay:ready', () => {
      if (anim instanceof _ImageAnimation.default || anim instanceof _TileAnimation.default) {
        anim.provider = this;
      }
    });
  }
  /** Animation Provider */
  animationLayerForDate(animation, date) {
    let wait = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return this.source.animationLayerForDate(animation, date, wait);
  }
}
var _default = exports.default = TileDataAnimator;
module.exports = exports.default;